import '../../style/style.css';
function RodapeBlog() {



    return (

        <>

            <div className="cabecalhoBlog rodapeBlog">

                <div><img src={'https://somosconexaosocial.org/site_img/blog-rebeca/rodape-foto.jpg'} alt="Techfest 2025" /></div>

                <div className='nomeDescricao'>

                    <h1>Sobre mim</h1>

                    <p>Sou Rebeca Lima, tenho 16 anos e moro em Lagoa de Itaenga-PE. Participei do Passaporte Digital e do Intercâmbio dos Saberes. Hoje, sigo como intercambista na Associação Conexão Social, onde continuo aprendendo e crescendo.</p>


                </div>             

            </div>

        </>


    );
}

export default RodapeBlog;